import { createContext } from 'react';

import type { UseThemeProps } from './types';

const ThemeContext = createContext<UseThemeProps | null>(null);

export default ThemeContext;
